module.exports = __webpack_public_path__ + "static/media/4.69e09411.png";